<template>
  <h1>CREATE CLIENT</h1>
</template>

<script>
export default {};
</script>
